import { render, staticRenderFns } from "./SmallLoaderComponent.vue?vue&type=template&id=d4a3848a&scoped=true"
import script from "./SmallLoaderComponent.vue?vue&type=script&lang=js"
export * from "./SmallLoaderComponent.vue?vue&type=script&lang=js"
import style0 from "./SmallLoaderComponent.vue?vue&type=style&index=0&id=d4a3848a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a3848a",
  null
  
)

export default component.exports